import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { OrthOV1RequestRead } from '../../OrthO/OrthOV1RequestRead';

export function OrthOFolV1RequestRead(props: ICustomControlRequestReadProps) {
    return (
        <OrthOV1RequestRead
            {...props}
            isOrthOFol
        />
    );
}
